import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";
import { Button } from "../ui/button";

export const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section data-testid="cta-section" className="py-20 px-4 sm:px-6 bg-gradient-to-r from-[#141414] to-[#0A0A0A] border-t border-white/5">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-4 tracking-tight">{t("contact.bookCta")}</h2>
        <Link to="/boeken">
          <Button data-testid="cta-book-button" className="bg-gold text-white hover:bg-gold-hover rounded-none px-10 py-6 text-base transition-colors">
            {t("hero.cta")}
          </Button>
        </Link>
      </div>
    </section>
  );
};
